import toast from 'react-hot-toast';
import { FailureEnvelop } from '@/types/api';
import { EXTRA_BOTTOM } from '@/features/toast-container/constant';
export const getCartErrorMessage = (error: FailureEnvelop['errors']) => {
  const errorCode = error?.at?.(0)?.code;
  switch (errorCode) {
    case 'cart_item_not_found':
      toast.error('محصول در سبد خرید پیدا نشد.', {
        duration: 3000,
        id: 'cart-item-not-found',
        style: {
          maxWidth: 'fit-content',
          bottom: EXTRA_BOTTOM
        }
      });
      setTimeout(() => {
        location.reload();
      }, 3000);
      break;
  }
};